import { css } from "@linaria/core";

export const badgeTextOverflow = css`
  max-width: 100%;
  overflow: hidden;

  & > span {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
`;
